// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  display: flex;
  position: relative;
  flex-direction: column;
  transition: all 1s ease-in-out;
  padding-top: 10px;
  height: 100vh;
  background-image: linear-gradient(to right, #390879, #390879, #390879, #390879, #390879, #311379, #2a1a78, #231f76, #152871, #0e2e6a, #133261, #1d3557);
  overflow: hidden;
}

img {
  width: 100%;
  height: 100%;
}

.main-section {
  display: flex;
  position: relative;
  flex-direction: row;
  height: 30em;
}

.main-container {
  display: flex;
  flex-direction: column;
}

.name-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4rem;
  letter-spacing: 1rem;
}

.company-title {
  font-family: "Spartan", sans-serif;
  color: #a5e300;
  font-size: 3rem;
  border-bottom: 1px solid white;
  margin: 0.5rem;
}

.company-ceo {
  font-family: "Spartan", sans-serif;
  color: #a5e300;
  font-size: 1.3rem;
  margin: 0.5rem;
}

.clip-container-1 {
  position: relative;
  width: 50em;
  transition: all 0.5s ease-in-out;
  opacity: 0.5;
  animation: full-stretch 1.3s 1s forwards ease-in-out;
}

.clip-container-2 {
  position: relative;
  width: 50em;
  transition: all 0.5s ease-in-out;
  opacity: 0.5;
  animation: full-stretch 1.3s 2.5s forwards ease-in-out;
}

.clip-container-3 {
  position: relative;
  width: 50em;
  transition: all 0.5s ease-in-out;
  opacity: 0.5;
  animation: full-stretch 1.3s 3.5s forwards ease-in-out;
}

@keyframes full-stretch {
  0% {
    opacity: 0.5;
    height: 100%;
  }
  100% {
    opacity: 1;
    height: 700px;
  }
}
.clip-text-1 {
  position: absolute;
  top: 40vh;
  left: 0;
  display: flex;
  font-family: "Julius Sans One", sans-serif;
  font-size: 30px;
  z-index: 1;
  opacity: 0;
  background-color: #a5e300;
  color: white;
  padding: 20px;
  border-radius: 1px;
  animation: animate-txt 1.3s 1s forwards ease-in-out;
}

.clip-text-2 {
  position: absolute;
  top: 40vh;
  left: 0;
  display: flex;
  font-family: "Julius Sans One", sans-serif;
  font-size: 30px;
  z-index: 1;
  opacity: 0;
  background-color: #337def;
  color: white;
  padding: 20px;
  border-radius: 1px;
  animation: animate-txt 1.3s 2.5s forwards ease-in-out;
}

.clip-text-3 {
  position: absolute;
  top: 40vh;
  left: 0;
  display: flex;
  font-family: "Julius Sans One", sans-serif;
  font-size: 30px;
  z-index: 1;
  opacity: 0;
  background-color: #00ffff;
  color: white;
  padding: 20px;
  border-radius: 1px;
  animation: animate-txt 1.3s 3.5s forwards ease-in-out;
}

@keyframes animate-txt {
  0% {
    opacity: 0;
    transform: translateY(20px);
    width: 50%;
  }
  100% {
    opacity: 1;
    transform: translateY(0);
    width: 5px;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 500px) {
  .clip-text-1,
  .clip-text-2,
  .clip-text-3 {
    font-size: 1.3rem;
  }
  .name-container {
    padding: 3rem;
    letter-spacing: 0.5rem;
  }
  .company-title {
    font-size: 2rem;
    text-align: center;
  }
  .company-ceo {
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Main/Styles.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;EACA,aAAA;EAEA,uJAAA;EAeA,gBAAA;AAdJ;;AAiBE;EACE,WAAA;EACA,YAAA;AAdJ;;AAiBE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAdJ;;AAiBE;EACE,aAAA;EACA,sBAAA;AAdJ;;AAiBE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AAdJ;;AAiBE;EACE,kCAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,cAAA;AAdJ;;AAiBE;EACE,kCAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;AAdJ;;AAiBE;EACE,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;EACA,oDAAA;AAdJ;;AAiBE;EACE,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;EACA,sDAAA;AAdJ;;AAiBE;EACE,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;EACA,sDAAA;AAdJ;;AAiBE;EACE;IACE,YAAA;IACA,YAAA;EAdJ;EAgBE;IACE,UAAA;IACA,aAAA;EAdJ;AACF;AAiBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,0CAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mDAAA;AAfJ;;AAkBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,0CAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qDAAA;AAfJ;;AAkBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,0CAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qDAAA;AAfJ;;AAkBE;EACE;IACE,UAAA;IACA,2BAAA;IACA,UAAA;EAfJ;EAiBE;IACE,UAAA;IACA,wBAAA;IACA,UAAA;EAfJ;AACF;AAkBE;EACE;IACE,UAAA;IACA,2BAAA;EAhBJ;EAkBE;IACE,UAAA;IACA,wBAAA;EAhBJ;AACF;AAmBE;EACE;;;IAGE,iBAAA;EAjBJ;EAoBE;IACE,aAAA;IACA,sBAAA;EAlBJ;EAqBE;IACE,eAAA;IACA,kBAAA;EAnBJ;EAsBE;IACE,iBAAA;EApBJ;AACF","sourcesContent":[".main {\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    transition: all 1s ease-in-out;\n    padding-top: 10px;\n    height: 100vh;\n    // background-color: #390879;\n    background-image: linear-gradient(\n      to right,\n      #390879,\n      #390879,\n      #390879,\n      #390879,\n      #390879,\n      #311379,\n      #2a1a78,\n      #231f76,\n      #152871,\n      #0e2e6a,\n      #133261,\n      #1d3557\n    );\n    overflow: hidden;\n  }\n  \n  img {\n    width: 100%;\n    height: 100%;\n  }\n  \n  .main-section {\n    display: flex;\n    position: relative;\n    flex-direction: row;\n    height: 30em;\n  }\n  \n  .main-container {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .name-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 4rem;\n    letter-spacing: 1rem;\n  }\n  \n  .company-title {\n    font-family: \"Spartan\", sans-serif;\n    color: #a5e300;\n    font-size: 3rem;\n    border-bottom: 1px solid white;\n    margin: 0.5rem;\n  }\n  \n  .company-ceo {\n    font-family: \"Spartan\", sans-serif;\n    color: #a5e300;\n    font-size: 1.3rem;\n    margin: 0.5rem;\n  }\n  \n  .clip-container-1 {\n    position: relative;\n    width: 50em;\n    transition: all 0.5s ease-in-out;\n    opacity: 0.5;\n    animation: full-stretch 1.3s 1s forwards ease-in-out;\n  }\n  \n  .clip-container-2 {\n    position: relative;\n    width: 50em;\n    transition: all 0.5s ease-in-out;\n    opacity: 0.5;\n    animation: full-stretch 1.3s 2.5s forwards ease-in-out;\n  }\n  \n  .clip-container-3 {\n    position: relative;\n    width: 50em;\n    transition: all 0.5s ease-in-out;\n    opacity: 0.5;\n    animation: full-stretch 1.3s 3.5s forwards ease-in-out;\n  }\n  \n  @keyframes full-stretch {\n    0% {\n      opacity: 0.5;\n      height: 100%;\n    }\n    100% {\n      opacity: 1;\n      height: 700px;\n    }\n  }\n  \n  .clip-text-1 {\n    position: absolute;\n    top: 40vh;\n    left: 0;\n    display: flex;\n    font-family: \"Julius Sans One\", sans-serif;\n    font-size: 30px;\n    z-index: 1;\n    opacity: 0;\n    background-color: #a5e300;\n    color: white;\n    padding: 20px;\n    border-radius: 1px;\n    animation: animate-txt 1.3s 1s forwards ease-in-out;\n  }\n  \n  .clip-text-2 {\n    position: absolute;\n    top: 40vh;\n    left: 0;\n    display: flex;\n    font-family: \"Julius Sans One\", sans-serif;\n    font-size: 30px;\n    z-index: 1;\n    opacity: 0;\n    background-color: #337def;\n    color: white;\n    padding: 20px;\n    border-radius: 1px;\n    animation: animate-txt 1.3s 2.5s forwards ease-in-out;\n  }\n  \n  .clip-text-3 {\n    position: absolute;\n    top: 40vh;\n    left: 0;\n    display: flex;\n    font-family: \"Julius Sans One\", sans-serif;\n    font-size: 30px;\n    z-index: 1;\n    opacity: 0;\n    background-color: #00ffff;\n    color: white;\n    padding: 20px;\n    border-radius: 1px;\n    animation: animate-txt 1.3s 3.5s forwards ease-in-out;\n  }\n  \n  @keyframes animate-txt {\n    0% {\n      opacity: 0;\n      transform: translateY(20px);\n      width: 50%;\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n      width: 5px;\n    }\n  }\n  \n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  @media (max-width: 500px) {\n    .clip-text-1,\n    .clip-text-2,\n    .clip-text-3 {\n      font-size: 1.3rem;\n    }\n  \n    .name-container {\n      padding: 3rem;\n      letter-spacing: 0.5rem;\n    }\n  \n    .company-title {\n      font-size: 2rem;\n      text-align: center;\n    }\n  \n    .company-ceo {\n      font-size: 0.9rem;\n    }\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
